import { useContext, createContext, useState } from "react";


const PlayContext = createContext();


const PlayProvider = ({children, ...rest}) =>
{

    const [op, setOp] = useState('');
    const [nid, setNid] = useState('');
 

    const [queryFilter, setQueryFilter] = useState({});


    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("success");

    const openSnackToast = (message, severity="success" )=>
    {
        setSnackOpen(true);
        setSnackMessage(message)
        setSnackSeverity(severity)
    }

    const [appTitle, setAppTitle] = useState(['idle-title','1',2]);
    
    

    const [status, setStatus] = useState('idle');
    const [errorTitle, setErrorTitle] = useState('');
    const [errorMessage, setErrorMessage] = useState('');



    const value = { 
        appTitle, setAppTitle,
        status, setStatus,
        errorTitle, setErrorTitle,
        errorMessage, setErrorMessage,
        

        snackOpen, setSnackOpen,
        snackMessage, setSnackMessage,
        snackSeverity, setSnackSeverity,
        openSnackToast,  
    
        op, setOp, nid, setNid,

        queryFilter, setQueryFilter,

    };

    return(    
        <PlayContext.Provider  value={value}>
            {children}
        </PlayContext.Provider>)  
}

export default PlayProvider

export const usePlayContext=()=> {
    return useContext(PlayContext);
}

